import React from 'react'
import { Checkbox, Input } from 'antd'

import styled from 'styled-components'

const OptionWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`

const FilterInternship = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`

const InternshipsFilter = ({
  InternshipsData,
  handleInternshipChange,
  selectInternship,
  handleInputChange,
}) => {
  const renderOptionInput = option => {
    if (option.hasInput) {
      return (
        <FilterInternship>
          <Input
            placeholder="From"
            style={{
              width: '80px',
              display: 'inline-block',
            }}
            disabled={selectInternship !== option.value}
            value={option.fromValue}
            onChange={e => {
              const inputValue = e.target.value
              if (/^\d*$/.test(inputValue)) {
                handleInputChange(
                  'From',
                  option.value,
                  inputValue,
                  option.status
                )
              }
            }}
          />
          -
          <Input
            placeholder="To"
            style={{
              width: '80px',
              display: 'inline-block',
            }}
            disabled={selectInternship !== option.value}
            value={option.toValue}
            onChange={e => {
              const inputValue = e.target.value
              if (/^\d*$/.test(inputValue)) {
                handleInputChange('To', option.value, inputValue, option.status)
              }
            }}
          />
        </FilterInternship>
      )
    }
    return null
  }

  return (
    <div>
      {InternshipsData.map(option => (
        <OptionWrapper key={option.value}>
          <Checkbox
            value={option.value}
            checked={selectInternship === option.value}
            onChange={() => handleInternshipChange(option.value)}
          >
            {option.label}
          </Checkbox>
          {renderOptionInput(option)}
        </OptionWrapper>
      ))}
    </div>
  )
}

export default InternshipsFilter
